ready().then(function() {

    /**
     *  On the 768-1023px layout we need to create an extra wrapper to achieve custom grid alignment
     */
    const adjustBookCardLayout = () => {
        let bookSummary = $('.section-book-summary');
        let sectionTitle = bookSummary.find('h2.section-title');

        sectionTitle.addClass('has-js has-active-js');
        sectionTitle.wrap('<div class="ui-grid-custom"></div>');
    }

    if (window.screen.width >= mdWidth && window.screen.width < lgWidth) {
        adjustBookCardLayout();
    }

});